import React from 'react';
import { ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section id="home" className="pt-28 pb-20 md:pt-36 md:pb-28 bg-gradient-to-br from-gray-50 to-white" data-id="element-128">
      <div className="container mx-auto px-4 md:px-6" data-id="element-129">
        <div className="flex flex-col md:flex-row items-center" data-id="element-130">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-131">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-132">
              <span className="block" data-id="element-133">Hi, I'm OTO</span>
              <span className="text-indigo-600" data-id="element-134">Digital Product Designer</span>
            </h1>
            <p className="text-lg text-gray-600 mb-8 max-w-md" data-id="element-135">
              I create innovative mobile applications and digital experiences
              that connect users with job opportunities in real-time.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-136">
              <a href="#projects" className="inline-flex items-center justify-center px-6 py-3 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors" data-id="element-137">
                View My Work <ArrowRight size={16} className="ml-2" data-id="element-138" />
              </a>
              <a href="#contact" className="inline-flex items-center justify-center px-6 py-3 border border-indigo-600 text-indigo-600 font-medium rounded-md hover:bg-indigo-50 transition-colors" data-id="element-139">
                Contact Me
              </a>
            </div>
          </div>
          <div className="md:w-1/2 md:pl-10" data-id="element-140">
            <div className="relative" data-id="element-141">
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-indigo-100 rounded-full z-0" data-id="element-142"></div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-indigo-100 rounded-full z-0" data-id="element-143"></div>
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iYEw8EqdDCGvqTT44jVtKR/26_100.png" alt="Digital product design showcase" className="rounded-lg shadow-lg relative z-10 w-full h-auto object-cover" data-id="element-144" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};